import { render, staticRenderFns } from "./PictureBookCaption.vue?vue&type=template&id=5f897927&"
import script from "./PictureBookCaption.vue?vue&type=script&lang=js&"
export * from "./PictureBookCaption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports